import React from 'react';
import { SITE } from '../lib/site';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream py-16 px-6">
      <div className="container mx-auto">
        <div className={`grid ${SITE.isSchool ? 'md:grid-cols-4' : 'md:grid-cols-5'} gap-12 mb-12`}>
          {/* Shop — hidden on school host */}
          {!SITE.isSchool && (
          <div>
            <h4 className="footer-title-streetwear">SHOP</h4>
            <ul className="footer-links-streetwear">
              <li><a href="/shop">Fashion</a></li>
              <li><a href="/collections/prsvr-sports">Sports</a></li>
              <li><a href="/collections/new-prsvr">New Drops</a></li>
              <li><a href="/collections/archive">ARCHIVE</a></li>
            </ul>
          </div>
          )}

          {/* Academy */}
          <div>
            <h4 className="footer-title-streetwear">ACADEMY</h4>
            <ul className="footer-links-streetwear">
              <li><a href="/academy">Athlete Lab</a></li>
              <li><a href="/academy?type=parent">Executive Mirror</a></li>
              <li><a href="/academy/login">Member Login</a></li>
              <li><a href="/academy/about">About SAA</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="footer-title-streetwear">COMPANY</h4>
            <ul className="footer-links-streetwear">
              <li><a href="/academy/about">Our Story</a></li>
              {!SITE.isSchool && <li><a href="/uniform-order">Custom Uniforms</a></li>}
              <li><a href="https://www.prsvr.store/blogs/press" target="_blank" rel="noopener noreferrer">Press</a></li>
              {!SITE.isSchool && <li><a href="/celebrities">Celebrities in PRSVR</a></li>}
              {SITE.isSchool && <li><a href="https://prsvr.store" target="_blank" rel="noopener noreferrer">PRSVR Apparel ↗</a></li>}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="footer-title-streetwear">CONNECT</h4>
            <ul className="footer-links-streetwear">
              <li><a href="https://www.youtube.com/@theprsvrfamily" target="_blank" rel="noopener noreferrer">YouTube</a></li>
              <li><a href="https://instagram.com/prsvr" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://www.linkedin.com/in/prsvr" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="footer-title-streetwear">CONTACT</h4>
            <p className="text-warmGray mb-2">Email: <a href="mailto:info@prsvr.com" className="hover:text-warmSage">info@prsvr.com</a></p>
            <p className="text-warmGray mb-2">Text: <a href="sms:6613831744" className="hover:text-warmSage">661.383.1744</a></p>
            <p className="text-warmGray">Los Angeles, CA</p>
          </div>
        </div>

        {/* Mission Statement */}
        <div className="border-t border-warmGray/20 pt-8 pb-8 text-center">
          <p className="text-warmGray/80 italic text-lg max-w-3xl mx-auto">
            "Strengthening the athlete and the scholar within, removing excuses from the playbook of your future."
          </p>
        </div>

        {/* Bottom Bar with PRSVR Logo */}
        <div className="border-t border-warmGray/20 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-warmGray">
          <div className="flex items-center gap-4 mb-4 md:mb-0">
            {/* PRSVR Logo - Monochrome/White */}
            <img 
              src="https://customer-assets.emergentagent.com/job_fashion-empire-2/artifacts/bcsdxd12_IMG_2797.PNG" 
              alt="PRSVR" 
              className="h-6 w-auto"
              style={{ filter: 'brightness(0) saturate(100%) invert(98%) sepia(6%) saturate(214%) hue-rotate(327deg) brightness(102%) contrast(96%)' }}
            />
            <p>&copy; 2026 {SITE.isSchool ? 'Scholar Athlete Academy. All rights reserved.' : 'PRSVR. All rights reserved.'}</p>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-4 mt-4 md:mt-0">
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a href="/privacy-policy" className="hover:text-warmSage transition-colors">Privacy Policy</a>
              <span>|</span>
              <a href="/terms-of-service" className="hover:text-warmSage transition-colors">Terms of Service</a>
              <span>|</span>
              <a href="/refund-policy" className="hover:text-warmSage transition-colors">Refund Policy</a>
              <span>|</span>
              <a href="/pricing-policy" className="hover:text-warmSage transition-colors">Pricing Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
